export default __webpack_public_path__ + "static/media/desktop_83.0728d6a3.jpg";